import ArticleLayout from './components/ArticleLayout';
import { articles } from '@/mocks/articles';

export default function ArticlePage() {
  return <ArticleLayout article={articles[0]} />;
}